#import "./TrainingComplianceCellFields.graphql"

query SearchTrainingCompliance(
  $page: Int
  $limit: Int
  $search: String
  $teamId: ID
  $overall: TrainingOverallStatusEnum
  $accessStatus: TrainingAccessStatusEnum
  $categoryId: ID
) {
  searchTrainingCompliance(
    page: $page
    limit: $limit
    search: $search
    teamId: $teamId
    overall: $overall
    accessStatus: $accessStatus
    categoryId: $categoryId
  ) {
    collection {
      employeeId
      name
      email
      team {
        id
        name
      }
      startDate
      overall
      accessStatus
      policiesAcknowledged
      policiesTotal
      cells {
        ...TrainingComplianceCellFields
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
